export const DigitalProductGuildsAssign = () => {
  return <>aa</>
}
